<div *ngIf="errors.length > 0" class="error-container">
  <div *ngFor="let error of errors">
    <p class="m-0 errorText">
      <small>{{ error.key }}:</small> {{ error.value }}
    </p>
  </div>
</div>
